import QASection from "./QASection";
import styles from "./style.module.scss";

const QAPage: React.FC = () => {
  return (
    <div className={styles.qaPage}>
      <div className={styles.container}>
        <h2 className={styles.title}>Frequently Asked Questions</h2>
        <p>
          Find answers to common questions about React development, best
          practices, and troubleshooting.
        </p>

        <QASection />
      </div>
    </div>
  );
};

export default QAPage;
